// Wait until the DOM is fully parsed before running any logic
document.addEventListener("DOMContentLoaded", function () {
	// Find the original header that should become "sticky"
	const header = document.querySelector(".sticky-header");

	// If there's no header, stop early
	if (!header) {
		return;
	}

	// Choose a container where the clone will be appended.
	// Prefer a site blocks wrapper when present, otherwise fall back to body.
	const container = document.querySelector(".wp-site-blocks") || document.body;

	// Make a deep clone of the header so we can show/hide it independently
	const clone = header.cloneNode(true);

	// Remove any id on the cloned root node to avoid duplicate IDs in the document
	if (clone.id) {
		clone.removeAttribute("id");
	}

	// Remove all ids inside the clone as well — duplicated ids are invalid in the DOM
	clone.querySelectorAll("[id]").forEach((el) => {
		el.removeAttribute("id");
	});

	// Mark the clone with a classname so CSS can target it
	clone.classList.add("sticky-clone");

	// Prevent assistive tech from interacting with the clone
	clone.setAttribute("aria-hidden", "true");

	// Make interactive elements inside the clone unfocusable (tabindex="-1")
	clone.querySelectorAll("a,button,input,select,textarea,[tabindex]").forEach((el) => {
		el.setAttribute("tabindex", "-1");
	});

	// Append the clone to the chosen container
	container.appendChild(clone);

	// Update clone's geometry and visual appearance to match the original header
	function updateCloneRect() {
		// Get header position & size relative to the viewport
		const rect = header.getBoundingClientRect();

		// Position and size the clone to match the header's width and left offset.
		// We clear top so the clone can be positioned via CSS (e.g. fixed at top).
		clone.style.width = rect.width + "px";
		clone.style.left = rect.left + "px";
		clone.style.top = "";

		// Try to copy background styles (color or image) so the clone visually matches.
		// This is wrapped in try/catch because some computedStyle access can throw on
		// cross-origin or unusual documents.
		try {
			const cs = getComputedStyle(header);

			// Prefer a solid background color if present and not transparent
			if (cs.backgroundColor && cs.backgroundColor !== "rgba(0, 0, 0, 0)") {
				clone.style.background = cs.backgroundColor;
			} else if (cs.backgroundImage && cs.backgroundImage !== "none") {
				// Otherwise prefer a background image if present
				clone.style.background = cs.background;
			} else {
				// Otherwise clear the background so CSS can decide the appearance
				clone.style.background = "";
			}
		} catch (e) {
			// If an error occurs reading computed styles, fail silently.
			// The clone will still work but might not perfectly match styles.
			// Intentionally empty.
		}
	}

	// Make the clone visible (adds a class which should trigger CSS transitions)
	function showClone() {
		// Ensure the clone geometry is up-to-date before showing
		updateCloneRect();

		clone.classList.add("is-visible");
	}

	// Hide the clone by removing the visibility class
	function hideClone() {
		clone.classList.remove("is-visible");
	}

	// Track last known scroll position to detect scroll direction
	let lastScrollY = window.scrollY;
	let scrollingUp = false;

	// Compute a threshold (in px) after which the sticky behavior should consider showing the clone.
	// This threshold is header's offsetTop + header height + extra spacing (40px).
	let threshold = header.offsetTop + header.offsetHeight + 40;

	// Recompute the threshold (useful on resize or when header size changes)
	function updateThreshold() {
		threshold = header.offsetTop + header.offsetHeight + 40;
	}

	// Decide whether the clone should be visible based on scroll position and direction.
	function checkThreshold() {
		const currentScrollY = window.scrollY;

		// If header has the modifier class `sticky-header--always-show` then we
		// show the clone whenever the scroll passes the threshold regardless of direction.
		const alwaysShow = header.classList.contains("sticky-header--always-show");

		let shouldBeVisible;

		if (alwaysShow) {
			shouldBeVisible = currentScrollY >= threshold;
		} else {
			// Otherwise, show the clone only when scrolled past threshold AND user is scrolling up.
			shouldBeVisible = currentScrollY >= threshold && scrollingUp;
		}

		if (shouldBeVisible) {
			// If it should be visible but isn't, show it; otherwise just update its rect.
			if (!clone.classList.contains("is-visible")) {
				showClone();
			} else {
				updateCloneRect();
			}
		} else {
			// If it should not be visible but currently is, hide it.
			if (clone.classList.contains("is-visible")) {
				hideClone();
			}
		}
	}

	// A flag to avoid queuing multiple rAF callbacks during fast scrolling
	let ticking = false;

	// Scroll handler updates direction and schedules a check on the next animation frame
	function onScroll() {
		const currentScrollY = window.scrollY;

		// Determine whether the user is scrolling up by comparing to the last Y position
		scrollingUp = currentScrollY < lastScrollY;

		// Store current position for the next event
		lastScrollY = currentScrollY;

		// Use requestAnimationFrame to limit how often we run the expensive checkThreshold
		if (!ticking) {
			window.requestAnimationFrame(() => {
				checkThreshold();
				// Allow scheduling another rAF
				ticking = false;
			});

			// Mark that a rAF is pending
			ticking = true;
		}
	}

	// Initial setup: compute threshold and check whether we should show the clone at load
	updateThreshold();
	checkThreshold();

	// Listen for scroll events (passive for better performance)
	window.addEventListener("scroll", onScroll, { passive: true });

	// On resize, update threshold and clone geometry if visible
	window.addEventListener("resize", () => {
		updateThreshold();

		if (clone.classList.contains("is-visible")) {
			updateCloneRect();
		}
	});

	// If ResizeObserver is available, watch the header for size changes so we can update threshold
	if ("ResizeObserver" in window) {
		const ro = new ResizeObserver(() => {
			updateThreshold();

			if (clone.classList.contains("is-visible")) {
				updateCloneRect();
			}
		});

		ro.observe(header);
	}

	// Hash navigation or history popstate can change scroll position — re-check visibility
	window.addEventListener("hashchange", checkThreshold);
	window.addEventListener("popstate", checkThreshold);
});
